import { PayrollReportSummaryViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const mockPayrollReportSummary: PayrollReportSummaryViewModel = {
  organizationName: 'BYGG CAPITOL AB',
  organizationNumber: '5564065760',
  payMonthSummary: [
    {
      payMonth: '202305',
      numberOfPays: 1,
      totalSum: 70000,
    },
    {
      payMonth: '202304',
      numberOfPays: 1,
      totalSum: 65000,
    },
    {
      payMonth: '202303',
      numberOfPays: 3,
      totalSum: 100000,
    },
  ],
};
